export default Object.freeze({
  GUTTER: 'Gouttières',
  FIXED_CONTENTION: 'Contentions fixes',
  REMOVABLE_CONTENTION: 'Contentions amovibles',
});
